export default __webpack_public_path__ + "static/media/ic-closeWhite.b33ee698.svg";